import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { BootstrapeModule } from '../bootstrape/bootstrape.module';





@NgModule({
  declarations: [
 
  ],
  imports: [
    CommonModule,
   
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BootstrapeModule,
   
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BootstrapeModule,
    
  ],
  providers: [provideHttpClient()],
})
export class SharedModule { }
